export const frData = {
  title: "Politique de Confidentialité et de Cookies – Danghuan",
  sections: [
    {
      title: "Introduction",
      content: `
        <p>La présente politique de confidentialité et de cookies explique comment Danghuan Europe S.L. (« nous » ou « Danghuan ») collecte, utilise et protège vos données personnelles lorsque vous interagissez avec nos sites internet et nos services. Elle s'applique aux résidents de l'Espace Économique Européen (EEE), y compris la France, et respecte les dispositions du Règlement Général sur la Protection des Données (RGPD).</p>
      `
    },
    {
      title: "Champ d'application",
      content: `
        <p>Cette politique s'applique à:</p>
        <ul style='list-style-type: disc; padding-left: 20px;'>
          <li style='margin-bottom: 8px;'>Visiteurs de notre site internet (https://www.danghuan.eu)</li>
          <li style='margin-bottom: 8px;'>Clients et prospects</li>
          <li style='margin-bottom: 8px;'>Utilisateurs de nos services de reprise et de revente</li>
          <li style='margin-bottom: 8px;'>Représentants de partenaires commerciaux et affiliés de plateformes tierces</li>
        </ul>
      `
    },
    {
      title: "Données personnelles collectées",
      content: `
        <p>Selon la nature de votre interaction, nous pouvons collecter:</p>
        <ul style='list-style-type: disc; padding-left: 20px;'>
          <li style='margin-bottom: 8px;'>Nom, adresse postale, adresse e-mail, numéro de téléphone</li>
          <li style='margin-bottom: 8px;'>Coordonnées bancaires (IBAN, code BIC, compte PayPal ou Revolut)</li>
          <li style='margin-bottom: 8px;'>Informations sur l'appareil (modèle, marque, état, IMEI, prix)</li>
          <li style='margin-bottom: 8px;'>Historique de communication avec notre service client</li>
          <li style='margin-bottom: 8px;'>Préférences marketing et interactions avec nos campagnes</li>
          <li style='margin-bottom: 8px;'>Adresse IP, type de navigateur, géolocalisation, identifiant de session</li>
          <li style='margin-bottom: 8px;'>Données transmises via des plateformes comme Shopify, Amazon, TEMU, Back Market</li>
        </ul>
        <p>Nous pouvons également recevoir certaines données de la part de nos partenaires logistiques ou commerciaux lorsque vous interagissez avec leurs plateformes.</p>
      `
    },
    {
      title: "Utilisation des données personnelles",
      content: `
        <p>Nous utilisons vos données afin de:</p>
        <ul style='list-style-type: disc; padding-left: 20px;'>
          <li style='margin-bottom: 8px;'>Traiter vos commandes et organiser la logistique (y compris retours et reprises)</li>
          <li style='margin-bottom: 8px;'>Vous informer concernant vos transactions</li>
          <li style='margin-bottom: 8px;'>Fournir une assistance clientèle</li>
          <li style='margin-bottom: 8px;'>Vous adresser des communications commerciales (si vous y avez consenti)</li>
          <li style='margin-bottom: 8px;'>Répondre à des obligations légales (ex.: fiscalité, prévention de la fraude)</li>
          <li style='margin-bottom: 8px;'>Améliorer l'expérience utilisateur et optimiser nos plateformes</li>
        </ul>
      `
    },
    {
      title: "Cookies",
      content: `
        <p>Nous utilisons des cookies pour améliorer votre navigation. Ils peuvent recueillir:</p>
        <ul style='list-style-type: disc; padding-left: 20px;'>
          <li style='margin-bottom: 8px;'>Adresse IP et données de géolocalisation</li>
          <li style='margin-bottom: 8px;'>Identifiants de navigateur ou appareil</li>
          <li style='margin-bottom: 8px;'>Comportement de navigation (pages consultées, clics, durée de session)</li>
        </ul>
        <p>Types de cookies utilisés:</p>
        <ul style='list-style-type: disc; padding-left: 20px;'>
          <li style='margin-bottom: 8px;'>Cookies strictement nécessaires</li>
          <li style='margin-bottom: 8px;'>Cookies fonctionnels</li>
          <li style='margin-bottom: 8px;'>Cookies de performance</li>
          <li style='margin-bottom: 8px;'>Cookies publicitaires</li>
        </ul>
        <p>Vous pouvez configurer ou retirer votre consentement à tout moment via votre navigateur ou le bandeau de gestion des cookies.</p>
      `
    },
    {
      title: "Partage avec des tiers",
      content: `
        <p>Vos données peuvent être partagées, dans le cadre de l'exécution de nos services, avec:</p>
        <ul style='list-style-type: disc; padding-left: 20px;'>
          <li style='margin-bottom: 8px;'>Fournisseurs de paiement: PayPal, Revolut, Stripe, VISA, Mastercard</li>
          <li style='margin-bottom: 8px;'>Prestataires logistiques: UPS, Correos, DPD, Royal Mail, NACEX, FedEx</li>
          <li style='margin-bottom: 8px;'>Plateformes partenaires: Shopify, Amazon, TEMU, BackMarket</li>
          <li style='margin-bottom: 8px;'>Prestataires marketing & analytiques: Google, Meta, TikTok, REDnote, X (Twitter), LinkedIn</li>
          <li style='margin-bottom: 8px;'>Prestataires IT, cabinets de conseil, juristes</li>
          <li style='margin-bottom: 8px;'>Autorités administratives, si la loi l'exige</li>
        </ul>
        <p>Des transferts hors UE peuvent être effectués sous garanties appropriées (ex.: clauses contractuelles types).</p>
      `
    },
    {
      title: "Utilisation de marques tierces",
      content: `
        <p>Notre site présente des marques telles que Apple, Samsung, OPPO, OnePlus, VIVO, Xiaomi, Google… uniquement dans un but descriptif pour identifier les appareils éligibles à nos services. Ces marques restent la propriété de leurs titulaires respectifs.</p>
        <p>Danghuan Europe S.L. est un prestataire indépendant non affilié à ces marques, sauf mention contraire.</p>
      `
    },
    {
      title: "Durée de conservation et sécurité des données",
      content: `
        <p>Vos données sont conservées uniquement pendant la durée nécessaire à leur traitement ou lorsque la loi l'exige.</p>
        <p>Des mesures de sécurité techniques et organisationnelles sont mises en place (cryptage, accès restreint, stockage sécurisé).</p>
      `
    },
    {
      title: "Vos droits",
      content: `
        <p>Nous nous engageons à répondre à toutes les demandes valides dans un délai d'un mois.</p>
        <p>Afin de protéger votre vie privée, nous pouvons exiger une vérification d'identité avant de traiter votre demande.</p>
        <p>Vous disposez des droits suivants:</p>
        <ul style='list-style-type: disc; padding-left: 20px;'>
          <li style='margin-bottom: 8px;'>Accéder à vos données personnelles et en demander la rectification</li>
          <li style='margin-bottom: 8px;'>Demander l'effacement de vos données (« droit à l'oubli »)</li>
          <li style='margin-bottom: 8px;'>Vous opposer au traitement de vos données ou en demander la limitation</li>
          <li style='margin-bottom: 8px;'>Retirer votre consentement à tout moment, sans affecter la légalité du traitement fondé sur le consentement avant son retrait</li>
          <li style='margin-bottom: 8px;'>Demander la portabilité de vos données, lorsque cela est applicable (notamment pour les traitements automatisés fondés sur votre consentement ou sur un contrat)</li>
        </ul>
        <p>Pour exercer ces droits, vous pouvez nous contacter à l'adresse suivante: <a href="mailto:privacy@danghuan.eu">privacy@danghuan.eu</a></p>
      `
    },
    {
      title: "Mises à jour de la politique",
      content: `
        <p>Nous pouvons mettre à jour la présente Politique de confidentialité afin de refléter des évolutions légales ou des modifications dans nos pratiques de traitement des données.</p>
        <p>La version la plus récente sera toujours disponible sur notre site internet.</p>
      `
    },
    {
      title: "Contact",
      content: `
        <p>Si vous avez des questions ou souhaitez exercer vos droits, vous pouvez nous contacter à l'adresse suivante:</p>
        <ul style='list-style-type: disc; padding-left: 20px;'>
          <li style='margin-bottom: 8px;'>Danghuan Europe S.L.</li>
          <li style='margin-bottom: 8px;'>Adresse e-mail: <a href="mailto:privacy@danghuan.eu">privacy@danghuan.eu</a></li>
          <li style='margin-bottom: 8px;'>Site web: <a href="https://www.danghuan.eu" target="_blank">https://www.danghuan.eu</a></li>
        </ul>
        <p>Vous avez également le droit d'introduire une réclamation auprès de votre autorité nationale de protection des données, ou en France, auprès de la Commission Nationale de l'Informatique et des Libertés (CNIL) – <a href="https://www.cnil.fr" target="_blank">www.cnil.fr</a>.</p>
      `
    },
    {
      title: "Annexe – Informations complémentaires sur la base légale et l'utilisation des cookies",
      subsections: [
        {
          title: "1. Base légale du traitement des données",
          content: `
            <p>La base juridique sur laquelle repose le traitement de vos données personnelles comprend:</p>
            <ul style='list-style-type: disc; padding-left: 20px;'>
              <li style='margin-bottom: 8px;'>L'exécution d'un contrat, par exemple pour traiter une commande de reprise ou effectuer un paiement</li>
              <li style='margin-bottom: 8px;'>Le respect d'obligations légales, telles que les obligations fiscales ou les vérifications d'identité</li>
              <li style='margin-bottom: 8px;'>Votre consentement, notamment pour les communications marketing ou l'utilisation de cookies tiers</li>
              <li style='margin-bottom: 8px;'>L'intérêt légitime de Danghuan Europe, par exemple pour la prévention de la fraude, les analyses internes ou l'amélioration de nos services</li>
            </ul>
          `
        },
        {
          title: "2. Mesures de prévention de la fraude",
          content: `
            <p>Nous pouvons utiliser certaines informations personnelles vous concernant (telles que le numéro de série de l'appareil, les modèles de transactions, l'adresse IP géolocalisée ou le nom du titulaire du compte bancaire) afin de procéder à des vérifications antifraude.</p>
            <p>Ces traitements sont réalisés dans le cadre de notre intérêt légitime à prévenir l'usurpation d'identité et les abus de nos services.</p>
            <p>Nous ne procédons à aucune prise de décision fondée exclusivement sur un traitement automatisé susceptible de produire des effets juridiques ou significatifs à votre égard.</p>
          `
        },
        {
          title: "3. Gestion des données sur les plateformes externes",
          content: `
            <p>Si vous achetez ou vendez des appareils via des plateformes tierces telles que Amazon, Shopify, TEMU ou BackMarket, Danghuan Europe S.L. peut recevoir des informations vous concernant, notamment vos données de commande, adresse de livraison et confirmation de paiement, par le biais d'une API sécurisée ou d'un canal de communication interne chiffré.</p>
            <p>Ces données ne sont utilisées exclusivement que dans le but de finaliser votre transaction et de vous fournir une assistance après-vente.</p>
          `
        },
        {
          title: "4. Catégories et détails des cookies",
          content: `
            <p>Vous pouvez consulter la liste complète des cookies que nous utilisons, y compris leur nom, fournisseur, finalité, durée et type (cookie de première ou de tierce partie), dans le tableau ci-dessous.</p>
            <table style='border-collapse: collapse; width: 100%;'>
              <thead>
                <tr>
                  <th style='border: 1px solid #ddd; padding: 8px;'>Catégorie</th>
                  <th style='border: 1px solid #ddd; padding: 8px;'>Nom du cookie</th>
                  <th style='border: 1px solid #ddd; padding: 8px;'>Fournisseur</th>
                  <th style='border: 1px solid #ddd; padding: 8px;'>Finalité</th>
                  <th style='border: 1px solid #ddd; padding: 8px;'>Durée</th>
                  <th style='border: 1px solid #ddd; padding: 8px;'>Type</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Strictement nécessaires</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>OptanonConsent</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>danghuan.eu</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Stocke les préférences en matière de cookies</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>1 an</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Première partie</td>
                </tr>
                <tr>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Strictement nécessaires</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>session_id</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>danghuan.eu</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Maintient l'état de la session</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Session</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Première partie</td>
                </tr>
                <tr>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Fonctionnels</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>i18next</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>danghuan.eu</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Mémorise la langue sélectionnée</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Session</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Première partie</td>
                </tr>
                <tr>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Fonctionnels</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>live_chat</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Tawk.to</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Active le chat en ligne avec le support</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>6 mois</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Tierce partie</td>
                </tr>
                <tr>
                  <td style='border: 1px solid #ddd; padding: 8px;'>De performance</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>_ga</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Google Analytics</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Collecte des statistiques sur l'utilisation du site</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>2 ans</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Tierce partie</td>
                </tr>
                <tr>
                  <td style='border: 1px solid #ddd; padding: 8px;'>De performance</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>_gid</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Google Analytics</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Suit le comportement de l'utilisateur</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>24 heures</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Tierce partie</td>
                </tr>
                <tr>
                  <td style='border: 1px solid #ddd; padding: 8px;'>De performance</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>_clck</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Microsoft Clarity</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Maintient un identifiant utilisateur unique</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>1 an</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Tierce partie</td>
                </tr>
                <tr>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Publicitaires</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>_fbp</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Meta (Facebook)</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Affiche des annonces personnalisées</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>3 mois</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Tierce partie</td>
                </tr>
                <tr>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Publicitaires</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>_tt_enable_cookie</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>TikTok</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Suit les conversions et interactions des utilisateurs</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>13 mois</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Tierce partie</td>
                </tr>
                <tr>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Publicitaires</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>_uetid</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Bing</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Suit l'utilisateur entre les sites</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>1 an</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Tierce partie</td>
                </tr>
                <tr>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Publicitaires</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>_gcl_au</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Google Ads</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Utilisé pour le suivi des conversions publicitaires</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>3 mois</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Tierce partie</td>
                </tr>
                <tr>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Publicitaires</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>_kla_id</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Klaviyo</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Identifie les visiteurs pour l'email marketing</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>2 ans</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Tierce partie</td>
                </tr>
              </tbody>
            </table>
          `
        },
        {
          title: "5. Promotions, campagnes et enquêtes",
          content: `
            <p>Lorsque vous participez à nos promotions, enquêtes ou jeux-concours, nous pouvons collecter votre nom, vos coordonnées de contact ainsi que d'autres informations spécifiques à l'événement (par exemple : âge, localisation).</p>
            <p>Ces données sont utilisées exclusivement pour organiser l'événement, contacter les gagnants et améliorer nos futures campagnes.</p>
          `
        },
        {
          title: "6. Autorités de supervision",
          content: `
            <p>Vous avez le droit d'introduire une réclamation auprès des autorités compétentes si vous estimez que vos droits en matière de protection des données n'ont pas été respectés.</p>
            <ul style='list-style-type: disc; padding-left: 20px;'>
              <li style='margin-bottom: 8px;'>En France: Commission Nationale de l'Informatique et des Libertés (CNIL) – <a href="https://www.cnil.fr" target="_blank">www.cnil.fr</a></li>
              <li style='margin-bottom: 8px;'>Au sein de l'Union européenne: Vous pouvez identifier l'autorité compétente de votre pays sur le site du Comité Européen de la Protection des Données (EDPB) – <a href="https://edpb.europa.eu/about-edpb/board/members_fr" target="_blank">https://edpb.europa.eu/about-edpb/board/members_fr</a></li>
            </ul>
          `
        }
      ]
    }
  ]
};